<template>
  <b-form @submit.prevent="showSendModal()">
    <b-form-group
      id="input-group-title"
      label="Name of Your Request"
      label-for="input-title"
      class="mb-4 font-weight-bold"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-input
        id="input-title"
        type="text"
        v-model="request.name"
        required
        placeholder="WA - Driver licence, SA - White card etc."
        :aria-describedby="ariaDescribedby"
        :loading="loading && formType === 'edit'"
        :disabled="loading && formType === 'edit'"
      ></b-form-input>

      <b-form-invalid-feedback id="input-title-feedback">
        <!-- eslint-disable-next-line -->
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      id="input-group-title"
      label="Name of Your Project or Site"
      label-for="input-title"
      class="mb-4 font-weight-bold"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-input
        id="input-title"
        type="text"
        v-model="request.project"
        required
        placeholder="WA - Driver licence, SA - White card etc."
        :aria-describedby="ariaDescribedby"
        :loading="loading && formType === 'edit'"
        :disabled="loading && formType === 'edit'"
      ></b-form-input>

      <b-form-invalid-feedback id="input-title-feedback">
        <!-- eslint-disable-next-line -->
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      id="input-group-title"
      label="Select the type of information you would like to be manually added on the file."
      label-for="input-title"
      class="mb-4 font-weight-bold"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-invalid-feedback
        class="mb-2 font-weight-normal"
        :state="infoTypeState"
        >The information types must have at least 1
        item.</b-form-invalid-feedback
      >
      <b-form-checkbox-group
        class="font-weight-normal type-group"
        id="checkbox-types"
        :aria-describedby="ariaDescribedby"
        v-model="request.information_types"
        name="types"
        stacked
        :loading="loading && formType === 'edit'"
        :disabled="loading && formType === 'edit'"
        ><b-form-checkbox
          v-for="type in infoTypes"
          :key="type.id"
          :value="type.id"
          class="mb-2"
        >
          {{ type.label }}
        </b-form-checkbox>
      </b-form-checkbox-group>

      <b-form-invalid-feedback id="input-title-feedback">
        <!-- eslint-disable-next-line -->
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group id="input-group-title">
      <h4 class="font-weight-bold mb-2">
        Add due date
      </h4>
      <b-col cols="6">
        <b-form-input
          id="input-date"
          type="text"
          required
          placeholder="DD/MM/YYYY"
          aria-describedby="input-date-feedback"
          maxlength="10"
          v-model="request.due_date"
          :formatter="formatDate"
          @input="onSelectedDate"
        />
        <span class="invalid-feedback d-block">
          {{ dateInvalid }}
        </span>
      </b-col>
    </b-form-group>

    <b-form-group id="input-group-title" v-slot="{ ariaDescribedby }">
      <h4 class="font-weight-bold mb-2">
        Instructions
      </h4>
      <b-form-textarea
        id="input-title"
        type="text"
        v-model="request.instruction"
        required
        placeholder="Please complete the form below and upload a high quality image of your file. If the file is hard to read, we may reject your file and you will have to re-upload another."
        class="font-weight-normal mb-2"
        rows="5"
        :aria-describedby="ariaDescribedby"
        :loading="loading && formType === 'edit'"
        :disabled="loading && formType === 'edit'"
      ></b-form-textarea>
    </b-form-group>

    <b-row class="mt-5">
      <b-col>
        <b-button
          block
          class="btn-outlined bg-white text-dark"
          variant="outline-secondary"
          :to="{
            path:
              formType === 'edit'
                ? `/request/to/${$route.params.id}`
                : '/request/templates'
          }"
          :loading="loading && formType === 'edit'"
          :disabled="loading && formType === 'edit'"
          >Discard</b-button
        >
      </b-col>
      <b-col>
        <b-button
          block
          type="submit"
          variant="primary"
          :loading="loading && formType === 'edit'"
          :disabled="(loading && formType === 'edit') || dateInvalid != null"
        >
          Next
        </b-button>
      </b-col>
    </b-row>
    <send-request-modal
      :showModal="showModal"
      :request="request"
      :formType="formType"
      @sendRequestResponse="sendRequestResponse"
      @closeModal="showModal = false"
    />
    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger'
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </b-form>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Form from '@/utils/form'
import SendRequestModal from '@/components/modals/SendRequestModal'

export default {
  name: 'RequestForm',

  components: {
    SendRequestModal
  },

  props: {
    formType: {
      type: String,
      default: 'add'
    },
    fileRequest: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModal: false,
      request: new Form({
        name: '',
        project: '',
        uploadType: '',
        due_date: null,
        instruction: '',
        information_types: [],
        emails: []
      }),
      selectedInfoTypes: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      infoTypeState: null,
      dateInvalid: null
    }
  },

  computed: {
    ...mapState({
      infoTypes: state => state.file.infoTypes
    })
  },

  methods: {
    ...mapActions({
      getInfoTypes: 'file/getInfoTypes'
    }),
    ...mapMutations({
      setCurrentScreen: 'file/setCurrentScreen'
    }),

    showSendModal() {
      this.infoTypeState = this.request.information_types.length >= 1
      if (this.infoTypeState) {
        this.showModal = true
      }
    },

    async sendRequestResponse(res) {
      if (this.formType === 'edit') {
        if (res.success) {
          this.alertMsg =
            'File shared successfully to selected emails: ' +
            res.emails.success.join(', ')

          this.dismissCountDown = 15

          return
        } else {
          this.alertType = 'danger'

          if (res.status === 402 || res.status === 422) {
            if (res.message) {
              this.alertMsg = res.message
            } else {
              this.alertMsg = 'File shared unsuccessful!'
            }
          } else {
            this.alertMsg =
              'Something went wrong while submitting the share file email!'
          }
        }
      } else {
        if (res.success) {
          this.alertMsg =
            'File shared successfully to selected emails: ' +
            res.data.success.join(', ')

          this.dismissCountDown = 15

          return
        } else {
          this.alertType = 'danger'

          if (res.status === 402 || res.status === 422) {
            if (res.message) {
              this.alertMsg = res.message
            } else {
              this.alertMsg = 'File shared unsuccessful!'
            }
          } else {
            this.alertMsg =
              'Something went wrong while submitting the share file email!'
          }
        }
      }

      this.form.$reset()
      this.dismissCountDown = 5
      this.clearAlert()
    },

    onSelectedDate(date) {
      if (date.length === 10) {
        this.dateInvalid = null
        this.selectedDate = this.convertToISO(date)
      } else {
        this.dateInvalid = 'Please input a valid date'
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    }
  },

  watch: {
    fileRequest(newVal, oldVal) {
      if (this.formType === 'edit' && newVal) {
        this.request.name = newVal.name
        this.request.project = newVal.project
        this.request.information_types = newVal.information_types.map(
          infoType => infoType.id
        )
        this.request.due_date = this.parseDate(newVal.due_date)
        this.request.instruction = newVal.instruction
        this.request.emails = newVal.requested_to
          ? newVal.requested_to.map(user => user.email)
          : []
      }
    },
    'request.information_types'(value) {
      this.infoTypeState = value.length >= 1
    }
  },

  created() {
    this.getInfoTypes()
  }
}
</script>

<style lang="scss" scoped>
.type-group {
  column-count: 2;

  @media (min-width: 767px) {
    padding-right: 10em;
  }
}
</style>
